import { z } from "zod";
const id = z.string().min(1).max(500);
export const assistantCmsMetadataInputSchema = z.object({
  offset: z.number().int().min(0).max(100000).default(0),
  limit: z.number().int().min(1).max(20).default(10),
}).strict();
export const assistantCmsFieldSchema = z.object({
  path: z.array(z.string().min(1).max(500)).min(1).max(8),
  type: z.enum(["text", "long-text", "number", "image", "file", "date-time", "boolean", "color", "rich-text", "ref", "list", "object", "enum"]),
  required: z.boolean(), localized: z.boolean(), unique: z.boolean(), hidden: z.boolean(),
  options: z.array(z.string().max(1000)).max(100).optional(),
  /** Native ref fields only: the table (of the same database) whose row ids the field holds. */
  refTableId: id.optional(),
}).strict();
export const assistantCmsTableMetadataSchema = z.object({
  id, identifier: z.string().max(500), name: z.string().max(1000),
  schemaDigest: z.string().regex(/^[a-f0-9]{64}$/),
  fields: z.array(assistantCmsFieldSchema).max(500),
}).strict();
export const assistantCmsMetadataOutputSchema = z.object({
  projectId: id, workspaceId: id.nullable(),
  databases: z.array(z.object({ id, name: z.string().max(1000), locales: z.array(z.string().max(100)).max(100), tables: z.array(assistantCmsTableMetadataSchema).max(100) }).strict()).max(20),
  total: z.number().int().nonnegative(), offset: z.number().int().nonnegative(), nextOffset: z.number().int().nonnegative().nullable(),
}).strict();
